import React from 'react';
import { Icon } from './Icon.js';
export const IconGridFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { x: "6.5", y: ".5", width: "5", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { x: ".5", y: "6.5", width: "5", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { x: ".5", y: ".5", width: "5", height: "5", rx: "1.75", ry: "1.75", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("rect", { x: "6.5", y: "6.5", width: "5", height: "5", rx: "1.75", ry: "1.75", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridFill12.js.map